import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgArrowDown = (props, ref) => /* @__PURE__ */ jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props, children: /* @__PURE__ */ jsx("path", { d: "M18 10.88L16.1418 9L11.9935 13.2267L7.84515 9L6 10.88L11.9935 17L18 10.88Z", fill: "currentColor" }) });
const ForwardRef = forwardRef(SvgArrowDown);
export { ForwardRef as ReactComponent };
